import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyScheduleList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/scheduleList" */ './ScheduleListRoot'), 'ScheduleList');
